<template>
  <main class="bonus-points">
    <template v-if="extension.payload && extension.payload.item_name">
      <section class="bonus-points-row">
        <div class="offer offer-name">
          <div class="offer-label">offer name</div>
          <div class="offer-value">{{ extension.payload.item_name }}</div>
        </div>
        <div class="offer bonus-type">
          <div class="offer-label">bonus type</div>
          <div class="offer-value">{{ extension.payload.bonus_type }}</div>
        </div>
        <div class="offer bonus-value">
          <div class="offer-label">bonus value</div>
          <div class="offer-value">{{ extension.payload.bonus_value }}</div>
        </div>
      </section>

      <section class="bonus-points-row">
        <div class="offer min-purchase">
          <div class="offer-label">min purchase amount</div>
          <div class="offer-value">${{ extension.payload.min_purchase_amount }}</div>
        </div>
        <div class="offer expiration">
          <div class="offer-label">expiration</div>
          <div class="offer-value">{{ expirationDate }} (midnight)</div>
        </div>
        <div class="offer use-per-customer">
          <div class="offer-label">uses per customer</div>
          <div class="offer-value">{{ usesPerCustomer }}</div>
        </div>
        <div class="offer display-image">
          <div class="offer-label">display image</div>
          <div class="offer-value">{{ hasDisplayImage }}</div>
        </div>
      </section>
    </template>
  </main>
</template>

<script>
import { utcToZonedTime } from "date-fns-tz";
import { format } from "date-fns";
import { mapGetters } from "vuex";

export default {
  props: {
    extension: Object
  },

  name: "bonus-points-preview",

  computed: {
    expirationDate() {
      const expirationDate = this.extension.payload?.expiration_date;
      return expirationDate ? format(utcToZonedTime(expirationDate, this.merchantTimeZone), "MM/dd/y") : null;
    },
    hasDisplayImage(){
      const displayImage = this.extension.payload?.has_preload_image;
      return displayImage ? "yes" : "no";
    },
    usesPerCustomer() {
      const maxRedemptions = this.extension.payload?.max_redemptions;
      return (maxRedemptions === -1) ? "unlimited" : maxRedemptions;
    },
    ...mapGetters(['merchantTimeZone'])
  }
}
</script>

<style scoped>
.bonus-points {
  width: 100%;
}

.offer {
  padding: 5px 6px;
}

.offer:not(:last-child){
  border-right: 1px solid #128ff9;
}

.bonus-points .offer-label {
  color: gray;
  font-size: .8em;
}

.bonus-points .offer-value {
  font-size: .9em;
}

.bonus-points-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.bonus-points-row > * {
  flex-grow: 1;
}

.bonus-points-row:first-child {
  border-bottom: 1px solid #128ff9;
}
</style>
